import { Box } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { GeneralTasksComponent } from './components/generalTasksComponent';
import { useGeneralTasksStore } from './hooks/useGeneralTasksStore';
import { GeneralTasksTab } from './types/generalTasksTypes';

export const MyOtherGeneralTasks = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();

  useEffect(() => {
    generalTasksStore.resetAndFetchOptions();
    generalTasksStore.setTab(GeneralTasksTab.MY_OTHER_TASKS);
    generalTasksStore.setTeamScope(false);
  }, []);

  return (
    <Box px={0.25} py={2} width="100%" bgcolor={'#fff'} style={{ flex: 1, flexDirection: "column", display: "flex" }}>
      <GeneralTasksComponent />
    </Box>
  );
});
